export default "<h1>{{ title }}</h1>\n<p>{{ message }}</p>";